import React, { useState, useRef, useEffect } from "react";
import useStyles from "./styles";
import { closeIcon, searchIcon } from "assets/icons/importIcon";
import { Button } from "@material-ui/core";
import noExercise from './img_no_excercise.png'
import AppHelper from 'helpers/AppHelper';
import { useDispatch, useSelector } from "react-redux";
import { getListExercise, getBrikloListExercise } from "actions/exercise";
import { createContent, getListSection, updateContent } from 'actions/brik';
import { debounce } from "lodash";
import { useDebounce } from 'common/hooks/useDebounce';
import { alertActions } from 'actions/alert.actions';
import CircularProgress from '@material-ui/core/CircularProgress';
import { logoIcon } from 'assets/icons';
import ThumbnailVideo from "components/Base/ThumbnailVideo";
import { Tabs } from "components/Base/Tabs";

const ListExercises = React.forwardRef((props: any, ref: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { brikId, sectionId, subId, lastContentOrder, isReplace, contentId } = props;
  const { 
    listdataExercise,
    dataCreate,
    loadList,
    loadBrikloExerciseList,
    brikloExercise 
  } = useSelector((state: any) => state.exercise);
  const limit = 12;
  const page = useRef(1);
  const briklopage = useRef(1);

  const [idActive, setIdActive] = useState<number>(-1);
  const [keyWordName, setKeyWordName] = useState<any>('');

  const [shouldLoadmore, setShouldLoadmore] = useState<boolean>(true);

  const debouncedSearch = useDebounce(keyWordName, 500);
  const [data, setData] = useState<any>([]);
  const [brikloData, setBrikloData] = useState<any>([]);
  const [selectedTab, setSelectedTab] = useState(0);

  const onClickCreateExerise = () => {
    AppHelper.showCreateExercise({ brikId, sectionId, subId, lastContentOrder });
  }

  const onHandleCloseModal = () => {
    AppHelper.hideGlobalModal();
  };

  const hanldeChangeSearch = (e: any) => {
    setKeyWordName(e?.target?.value.trim());
  };

  const handleDone = async (selectedId: any) => {
    if (selectedId === -1) {
      dispatch(alertActions.error('Please choose a exercise'));
      return
    }
    AppHelper.hideGlobalModal();

    if (isReplace) {
      const params = {
        exercise_id: selectedId,
      }
      await dispatch(updateContent(brikId, sectionId, subId, contentId, params))
    } else {
      await dispatch(createContent(brikId, sectionId, subId, {
        order: lastContentOrder + 1,
        type: "exercise",
        exercise_id: selectedId,
        quantity: 1,
        type_duration: 0
      }));
    }
    await dispatch(getListSection(brikId))
  }

  const getDataListExercises = () => {
    dispatch(getListExercise(page.current, limit, debouncedSearch));
  };

  const getBrikloListExercises = () => {
    dispatch(getBrikloListExercise(briklopage?.current, limit, debouncedSearch));
  };

  const onScroll = (e: any) => {
    if ((e?.target?.clientHeight + e?.target?.scrollTop) >= (e?.target?.scrollHeight )) {
      if (shouldLoadmore) {
        page.current = page.current + 1;
        getDataListExercises();
      }
    }
  };

  const onBrikloScroll = (e: any) => {
    if ((e?.target?.clientHeight + e?.target?.scrollTop) >= (e?.target?.scrollHeight)) {

      if (shouldLoadmore) {
        briklopage.current = briklopage.current + 1;
        getBrikloListExercises();
      }

    }
  };

  useEffect(() => {
    if(dataCreate?.success){
      getDataListExercises();
    }
  }, [dataCreate]);

  useEffect(() => {
    dispatch(getListExercise(1, limit, debouncedSearch));
  }, [debouncedSearch]);

  useEffect(() => {
    if (selectedTab === 0) {
      page.current = 1;
      getDataListExercises();
    } else if (selectedTab === 1) {
      briklopage.current = 1;
      getBrikloListExercises();
    }
  }, [debouncedSearch]);

  useEffect(() => {
    if (listdataExercise?.data?.length > 0) {
      if (page.current === 1) {
        setData(listdataExercise?.data);
      } else {
        setData([...data, ...listdataExercise?.data]);
      }
    } else {
      setShouldLoadmore(false);
    }
  }, [listdataExercise]);

  useEffect(() => {
    if (brikloExercise?.data?.length > 0) {
      if (briklopage?.current === 1) {
        setBrikloData(brikloExercise?.data);
      } else {
        setBrikloData([...brikloData, ...brikloExercise?.data]);
      }
    } else {
      setShouldLoadmore(false);
    }
  }, [brikloExercise]);

  const setTab = (tabIndex: number) => {
    setSelectedTab(tabIndex);
    if (tabIndex === 0) {
      page.current = 1;
      setShouldLoadmore(true);
      getDataListExercises();
    } else if (tabIndex === 1) {
      briklopage.current = 1;
      setShouldLoadmore(true);
      getBrikloListExercises();
    }
  }

  const getHeader = () => {
    return (
      <div
        className={classes.headerModal}
        style={{
          boxShadow:
            (data?.length !== 0 || keyWordName !== '')
              ? "1px 1px 6px rgba(56, 25, 81, 0.25)"
              : "",
        }}
      >
        <div className={classes.titleModal}>
          <p>Add an exercise</p>
          {/* <p>Select the exercises you would like to add.</p> */}

          <div className={classes.tab}>
            <div 
              className={selectedTab === 0 ? classes.tabLabelSelected : classes.tabLabel}
              onClick={() => setTab(0)}
            >
              My Exercises
            </div>
            <div 
              className={selectedTab === 1 ? classes.tabLabelSelected : classes.tabLabel}
              onClick={() => setTab(1)}
            >
                Briklo Exercises
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', }}>
          <div style={{ display: "flex", justifyContent: "flex-end", cursor: 'pointer' }}>
            <img src={closeIcon} alt="" onClick={onHandleCloseModal} />
          </div>
          {(data?.length > 0 || debouncedSearch) && (
            <div className={classes.dFlexRight}>
              <div className={classes.btnAddExerciseHeader} onClick={onClickCreateExerise}>+ New exercise</div>
              <div className={classes.wrapSearch}>
                <span>
                  <img src={searchIcon} alt="icon" />{" "}
                </span>
                <input type="text" placeholder="Search an exercise" onChange={debounce(hanldeChangeSearch, 500, {
                  leading: true,
                  trailing: false,
                })} />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const getContent = () => {
    if (selectedTab === 0) {
      return (
        <>
          {
            (loadList && (page.current === 1 || !page.current)) ? <div className={classes.styleLoadingPage}>
              <CircularProgress color='inherit' />
            </div> : <>
              {data && data.length === 0 ? (
                <div className={classes.bodyModal}>
                  <div className={classes.noExercise}>
                    <img src={noExercise} alt="no exercise" />
                    <p className={classes.fontMon16}>You don’t have any exercises to choose from.</p>
                    {
                      !debouncedSearch && <div className={classes.btnAddExerciseBody} onClick={onClickCreateExerise}>
                        <Button variant="contained">Create an Exercise</Button>
                      </div>
                    }
                  </div>
                </div>
              ) : (
                <>
                  <div className={`${classes.bodyModalList} ${classes.fixedHeightList}`} onScroll={onScroll}>
                    <div className={classes.listExercises}>
                      {data?.length > 0 && data?.map((item: any, index: any) => (
                        <>
                          {(item?.url || item?.file) && <div key={item?.url || item?.file || ''} className={`${classes.itemExercise} ${item?.id === idActive ? 'active' : ''}`}
                              onClick={() => {
                                setIdActive(item?.id)
                                handleDone(item?.id)
                              }}>
                              {item?.url ? <ThumbnailVideo videoUrl={item?.url} /> : null}
                              {item?.videoThumbnail ? 
                                <img src={item?.videoThumbnail.includes("http") ? item?.videoThumbnail : `${process.env.REACT_APP_STORAGE_DOMAIN}/${item?.videoThumbnail}`} width={'120px'} /> :
                                <img src={item?.file?.includes("http") && item?.videoThumbnail === null  ? item?.file : `${process.env.REACT_APP_STORAGE_DOMAIN}/${item?.file}`}  width={'120px'} />}

                              <div className={classes.contentExercise}>
                                <p className={classes.titleExercise}>
                                  {item?.name}
                                </p>
                                <p className={classes.subTitle}>{item?.description}</p>
                              </div>
                            </div>}
                        </>
                      ))}
                    </div>
                    {loadList && page.current > 1 ? (
                      <div className={classes.viewIconLoadmore}>
                        <div className={classes.logoIconLoadmore}>
                          <img src={logoIcon} alt='' />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </>
              )}
            </>
          }
        </>
      );
    }

    return (
      <>
      {
        (loadBrikloExerciseList && (briklopage.current === 1 || !briklopage.current)) ? <div className={classes.styleLoadingPage}>
          <CircularProgress color='inherit' />
        </div> : <>
          {brikloData && brikloData.length === 0 ? (
            <div className={classes.bodyModal}>
              <div className={classes.noExercise}>
                <img src={noExercise} alt="no exercise" />
                <p className={classes.fontMon16}>You don’t have any exercises to choose from.</p>
                {
                  !debouncedSearch && <div className={classes.btnAddExerciseBody} onClick={onClickCreateExerise}>
                    <Button variant="contained">Create an Exercise</Button>
                  </div>
                }
              </div>
            </div>
          ) : (
            <>
              <div className={`${classes.bodyModalList} ${classes.fixedHeightList}`} onScroll={onBrikloScroll}>
                <div className={classes.listExercises}>
                  {brikloData?.length > 0 && brikloData?.map((item: any, index: any) => (
                    <>
                      {(item?.url || item?.file) && <div key={item?.url || item?.file || ''} className={`${classes.itemExercise} ${item?.id === idActive ? 'active' : ''}`}
                          onClick={() => {
                            setIdActive(item?.id)
                            handleDone(item?.id)
                          }}>
                          {item?.url ? <ThumbnailVideo videoUrl={item?.url} /> : null}
                          {item?.videoThumbnail ? 
                            <img src={item?.videoThumbnail.includes("http") ? item?.videoThumbnail : `${process.env.REACT_APP_STORAGE_DOMAIN}/${item?.videoThumbnail}`} width={'120px'} /> :
                            <img src={item?.file?.includes("http") && item?.videoThumbnail === null  ? item?.file : `${process.env.REACT_APP_STORAGE_DOMAIN}/${item?.file}`}  width={'120px'} />}

                          <div className={classes.contentExercise}>
                            <p className={classes.titleExercise}>
                              {item?.name}
                            </p>
                            <p className={classes.subTitle}>{item?.description}</p>
                          </div>
                        </div>}
                    </>
                  ))}
                </div>
                {loadBrikloExerciseList && briklopage?.current > 1 ? (
                  <div className={classes.viewIconLoadmore}>
                    <div className={classes.logoIconLoadmore}>
                      <img src={logoIcon} alt='' />
                    </div>
                  </div>
                ) : null}
              </div>
            </>
          )}
        </>
      }
    </>
    );
  }

  return (
    <>
      <div className={classes.container}>
        <Tabs
            customHeader={getHeader()}
            children= {getContent()}
          />
      </div>
    </>
  );
});

export default ListExercises;